import { NgModule } from '@angular/core';
import { AuthGuard } from '../sharedcomponents/_common/auth.guard';
import { Routes, RouterModule } from '@angular/router';
import { transactionlistcomponent } from '../transaction-history/transaction-list/transaction-list.component';
import { TransactionListUserComponent } from '../transaction-history/transaction-list-user/transaction-list-user.component';
import { TransactionListUserDetailComponent } from '../transaction-history/transaction-list-user-detail/transaction-list-user-detail.component';
import { TransDebitCardComponent } from '../transaction-history/trans-debit-card/trans-debit-card.component';
import { GetReceiptComponent } from '../transaction-history/get-receipt/get-receipt.component';
import { PayagainFailedorderComponent } from '../transaction-history/payagain-failedorder/payagain-failedorder.component';

import { sharedModule  } from '../sharedcomponents/shared-routing.module';
import { CommonModule } from '@angular/common';
import { BusyModule } from 'angular2-busy';
import { TranslateHttpLoader,  } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateService } from 'ng2-translate';
import { FormsModule } from '@angular/forms';
import { CardlistComponent } from '../mywallet/card/cardlist/cardlist.component';
import { ModalModule } from 'angular2-modal';
import { BootstrapModalModule } from 'angular2-modal/plugins/bootstrap';
import { PerfectScrollbarModule } from 'angular2-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'angular2-perfect-scrollbar';

const PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

const routes: Routes = [
  { path: 'transactionlist', component: transactionlistcomponent, canActivate: [AuthGuard] },
  { path: 'transactionuserlist', component: TransactionListUserComponent, canActivate: [AuthGuard] },
  { path: 'transactionuserlistrepay', component: TransactionListUserComponent, canActivate: [AuthGuard] },
  { path: 'transactionuserlists', component: TransactionListUserComponent, canActivate: [AuthGuard] },

];

@NgModule({
  imports: [
    PerfectScrollbarModule.forRoot(PERFECT_SCROLLBAR_CONFIG),
    RouterModule.forChild(routes),
    sharedModule,
    CommonModule,
    BusyModule,
    FormsModule,
    BootstrapModalModule,
    TranslateModule,
    ModalModule.forRoot(),

  ],
  declarations: [
    transactionlistcomponent,
    TransactionListUserComponent,
    TransactionListUserDetailComponent,
    TransDebitCardComponent,
    GetReceiptComponent,
    PayagainFailedorderComponent,
    CardlistComponent
  ],
  exports: [
    transactionlistcomponent,
    TransactionListUserComponent,
    CardlistComponent
  ],
  entryComponents: [
    GetReceiptComponent,
    PayagainFailedorderComponent
  ],

})
export class transactionhistoryModule {

}



// WEBPACK FOOTER //
// ./src/app/transaction-history/transaction-routing.module.ts